// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"ef1fb349","401":"02c1bd59","480":"23baca9e","542":"4470072c","558":"19050817","577":"2e79d834","830":"dec97bb2","981":"85aa7a49"}[chunkId] + ".chunk.js";
};